import useSWR, { type SWRConfiguration } from 'swr';
import denApi from '@/lib/api/denApi';
import { MultichainAccountUsdDetails } from '@mls-wallet/shared-types';

const accountUsdDetailsFetcher = async (
  url: string
): Promise<MultichainAccountUsdDetails> =>
  await denApi.get<MultichainAccountUsdDetails, void>(url);

// Hook for fetching the server-composed USD details for a specific account.
export function useAccountUsdDetails(
  accountId: string,
  swrOptions?: SWRConfiguration<MultichainAccountUsdDetails>
) {
  const { data, error, isLoading, mutate } =
    useSWR<MultichainAccountUsdDetails>(
      `multichain-account/${accountId}/usd-details`,
      accountUsdDetailsFetcher,
      { revalidateOnFocus: false, ...(swrOptions ?? {}) }
    );

  return {
    accountUsdDetails: data ?? null,
    isLoading,
    error,
    refresh: mutate,
  };
}
